import AudioClipContainer from "../AudioClipContainer";
import React, { useEffect, useRef, useState } from "react";
import { Timer } from "../CountdownTimer";
import { MCQKeyboard } from "../MCQKeyboard";
import { NEW_FORMAT_TOURNAMENT_GAME_TIMER, NEW_FORMAT_TOURNAMENT_GAME_TRIAL_TIMER } from "../../../../../Constants/Commons";
import { Dialog } from "@mui/material";
import AppButton from "../../../../Common/AppButton";
import { MCQComprehensionKeyboard } from "../MCQComprehensionKeyboard";
import { set } from "lodash";

export const AudioComprehension = ({ currentActiveQuestion, submitGame, updateGameState, gameState, isTrialGame, questionsList, currentActiveIndex = 0, totalQuestions = 1, roundsPerQuestion, props }) => {

    const roundTimerDuration = isTrialGame ? NEW_FORMAT_TOURNAMENT_GAME_TRIAL_TIMER["AUDIO_COMPREHENSION"] : NEW_FORMAT_TOURNAMENT_GAME_TIMER["AUDIO_COMPREHENSION"];
    const [showAudioScreen, setShowAudioScreen] = useState(true);
    const [audioCompleted, setAudioCompleted] = useState(false);
    const [pauseTimer, setPauseTimer] = useState(true);
    const [localQuestionIndex, setLocalQuestionIndex] = useState(0);
    const [showScorePopup, setShowScorePopup] = useState(false);
    const [currentScore, setCurrentScore] = useState({ score: 0, correct: 0 });
    const [questionData, setQuestionData] = useState({});
    const [stopAudio, setStopAudio] = useState(false);


    useEffect(() => {
        setShowAudioScreen(true);
        setAudioCompleted(false);
        setPauseTimer(true);
        setLocalQuestionIndex(0);
        setShowScorePopup(false);
        setCurrentScore({ score: 0, correct: 0 });
        setQuestionData(currentActiveQuestion);
        setStopAudio(false);
        // scoreRef.current = 0;

    }, [currentActiveIndex]);

    useEffect(() => {
        setStopAudio(false);
    }, [localQuestionIndex]);

    const timerRef = useRef(null);
    const scoreRef = useRef(0);

    useEffect(() => {
        if (audioCompleted) {
            setShowAudioScreen(false);
            setAudioCompleted(false);
            setPauseTimer(false);
        }
    }, [audioCompleted]);


    const handleSubmitAnswer = (selectedOption = "", skipped) => {
        //calculate score and and write to db if maingame.
        setStopAudio(true);
        const currentLocalQuestion = questionData.questions[localQuestionIndex];
        let attempts = gameState.attempts;
        let correctAttempts = gameState.correctAttempts;
        let currentCorrectAttempts = currentScore.correct;
        let accuracyBonus = 0;
        if (selectedOption.toLowerCase() === currentLocalQuestion.answer.toLowerCase()) {
            currentCorrectAttempts = currentCorrectAttempts + 1;
            scoreRef.current = scoreRef.current + 2;
            correctAttempts = correctAttempts + 1;
            attempts = attempts + 1;

            if (localQuestionIndex == questionData.questions.length - 1) {
                if (currentCorrectAttempts == 5) {
                    accuracyBonus = 3;
                } else if (currentCorrectAttempts == 4 || currentCorrectAttempts == 3) {
                    accuracyBonus = 1;
                }
            }

            scoreRef.current = scoreRef.current + accuracyBonus;


            setCurrentScore((prev) => ({
                score: prev.score + 2 + accuracyBonus,
                correct: prev.correct + 1,
                accuracyBonus: accuracyBonus,
            }));
            props.setSnackBar({
                open: true,
                message: "CORRECT",
                type: "success",
                duration: 1500,
            });
        }
        else {
            attempts = attempts + 1;
            if (localQuestionIndex == questionData.questions.length - 1) {
                if (currentCorrectAttempts == 5) {
                    accuracyBonus = 3;
                } else if (currentCorrectAttempts == 4 || currentCorrectAttempts == 3) {
                    accuracyBonus = 1;
                }
            }

            scoreRef.current = scoreRef.current + accuracyBonus;

            setCurrentScore((prev) => ({
                score: prev.score + accuracyBonus,
                correct: prev.correct,
                accuracyBonus: accuracyBonus,
            }));
            props.setSnackBar({
                open: true,
                message: "INCORRECT",
                type: "error",
                duration: 1500,
            });
        }

        const userResponses = gameState.userResponses || [];

        const currentQuestion = {
            question: currentLocalQuestion.question,
            answer: currentLocalQuestion.answer,
            selectedOption: selectedOption,
            timeTaken: roundTimerDuration - timerRef.current,
            currentActiveIndex: currentActiveIndex,
            audioClip: questionData.audioClip,
            accuracyBonus: accuracyBonus,
        }
        userResponses.push(currentQuestion);

        const updatedGameState = {
            ...gameState,
            score: scoreRef.current,
            attempts: attempts,
            correctAttempts: correctAttempts,
            userResponses: userResponses,
        };

        if (!isTrialGame) {
            updateGameState(updatedGameState);
        }

        if (localQuestionIndex < questionData.questions.length - 1) {
            setLocalQuestionIndex(localQuestionIndex + 1);
        }
        else {
            setShowScorePopup(true);
            setPauseTimer(true);
        }

    }

    const handleTimerEnd = () => {
        setShowScorePopup(true);
        setPauseTimer(true);
    }






    const renderScorePopup = () => {
        return (
            <Dialog
                open={showScorePopup}
                onClose={() => { setShowScorePopup(false); submitGame(isTrialGame) }}
                className="register-success"
            >
                <div className="relative flex flex-col bg-primary-gradient text-white h-full overflow-hidden px-6 py-10 leading-6 items-center justify-center">
                    <div
                        style={{ fontFamily: '"Avenir Heavy", Avenir, sans-serif' }}
                        className="text-[18px]"
                    >
                        AUDIO {currentActiveIndex + 1}/{totalQuestions}
                    </div>

                    <div
                        style={{ fontFamily: '"Avenir Medium", Avenir, sans-serif' }}
                        className="w-[90%] grid grid-cols-2 gap-x-5 mt-4"
                    >
                        {/* Column 1 */}
                        <div className="flex flex-col items-center gap-4">
                            <span className="text-[14px]">Score</span>
                            <span className="text-[14px]">Correct</span>
                            <span className="text-[14px]">Accuracy Bonus</span>
                        </div>

                        {/* Column 2 */}
                        <div className="flex flex-col items-center gap-4">
                            <span className="text-[14px]">{currentScore.score}</span>
                            <span className="text-[14px]">{currentScore.correct}</span>
                            <span className="text-[14px]">{currentScore.accuracyBonus ?? 0}</span>
                        </div>
                    </div>

                    <div className="flex flex-col items-center  justift-center gap-4 mt-[50px]"
                                                style={{ fontFamily: '"Avenir Medium", Avenir, sans-serif' }}
                    >
                        <span className="text-[14px]">Total Round Score : {scoreRef.current}</span>
                    </div>
                    <AppButton
                        onClick={() => submitGame(isTrialGame)}
                        className="rounded-[115px] min-w-[159px] w-[159px] h-[35px] mt-8 min-h-[35px] self-center"
                    >
                        Proceed To Next
                    </AppButton>
                </div>
            </Dialog>
        );
    }


    return (
        <div className="h-screen w-screen flex flex-col items-center justify-start">

            {showAudioScreen ? (
                <>
                    <div className="w-full flex justify-between mt-2">
                        <div className="flex flex-col items-center justify-center w-full h-full text-[14px]">
                            <span className="text-[20px] text-center">Ques</span>
                            <span className="text-[20px] text-center">
                                {0}/{questionData?.questions?.length}
                            </span>
                        </div>

                        <Timer
                            duration={roundTimerDuration}
                            stroke={5}
                            timerEnd={handleTimerEnd}
                            startTimer={!pauseTimer}
                            key={currentActiveIndex}
                            localTimer={true}
                            color="black"
                            timeRef={timerRef}
                        />

                        <div className="flex flex-col items-center justify-center w-full h-full text-[14px]">
                            <span className="text-[20px] text-center">Score</span>
                            <span className="text-[20px] text-center">{scoreRef.current}</span>
                        </div>
                    </div>

                    <div className="flex flex-col w-full h-full text-[14px] mt-[10vh]">
                        <span className="text-[24px] text-center">AUDIO {currentActiveIndex + 1}/{totalQuestions}</span>

                        <span className="text-[18px] text-center mt-[10vh] mx-5">Hear the audio clip then answer questions based on it</span>

                        <AudioClipContainer question={questionData} setAudioCompleted={setAudioCompleted} stopAudio={stopAudio} text={"PLAY"} />
                    </div>
                </>
            ) : (


                <div className="h-[calc(100vh-300px)] w-screen flex flex-col items-center justify-between">
                    <div className="w-full flex justify-between">
                        <div className="flex flex-col items-center justify-center w-full h-full text-[14px]">
                            <span className="text-[20px] text-center">Ques</span>
                            <span className="text-[20px] text-center">
                                {localQuestionIndex + 1}/{questionData?.questions?.length}
                            </span>
                        </div>

                        <Timer
                            duration={roundTimerDuration}
                            stroke={5}
                            timerEnd={handleTimerEnd}
                            startTimer={!pauseTimer}
                            key={currentActiveIndex}
                            localTimer={true}
                            color="black"
                            timeRef={timerRef}
                        />

                        <div className="flex flex-col items-center justify-center w-full h-full text-[14px]">
                            <span className="text-[20px] text-center">Score</span>
                            <span className="text-[20px] text-center">{scoreRef.current}</span>
                        </div>
                    </div>

                    <span className="text-[18px] mx-5">{questionData.questions[localQuestionIndex].question}</span>

                    <AudioClipContainer question={questionData} setAudioCompleted={setAudioCompleted} stopAudio={stopAudio} text={"PLAY"} />
                    <div
                        style={{
                            maxWidth: "800px",
                            margin: "15px auto 0 auto",
                            position: "absolute",
                            bottom: "0",
                            width: "100%",
                        }}
                    >
                        <MCQComprehensionKeyboard
                            question={questionData.questions[localQuestionIndex]}
                            onSubmit={handleSubmitAnswer}
                            enableSkip={false}
                        />
                    </div>
                    {/* </div> */}
                    {/* </div> */}
                    {renderScorePopup()}
                </div>
            )
            }
        </div>
    );
}